import { turnToConfig } from 'init/config'

/**
 * Interface for the state property inside the store
 */
export interface IGalleryStoreState {
  skus?: Array<string>
  tags?: Array<string>
  onFinish?: Function
}

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
export class Store {
  constructor() {
    const clientGalleryConfig = turnToConfig.gallery || {}
    this.state.skus = clientGalleryConfig.skus
    this.state.tags = clientGalleryConfig.tags
    this.state.onFinish = clientGalleryConfig.onFinish
  }

  state: IGalleryStoreState = {
    skus: undefined,
    tags: undefined,
    onFinish: undefined
  }

  set skus(skus: Array<string>) {
    this.state.skus = skus
  }
  get skus(): Array<string> {
    return this.state.skus
  }

  set tags(tags: Array<string>) {
    this.state.tags = tags
  }
  get tags(): Array<string> {
    return this.state.tags
  }

  set onFinish(onFinish: Function) {
    this.state.onFinish = onFinish
  }
  get onFinish(): Function {
    return this.state.onFinish
  }
}

export default new Store()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/store/gallery-widget-store.ts